<div class="phones">
  @if (phone || mobilePhone) {
    @if (phone) {
      <span class="phones__row"><span class="phones__label">Office</span> {{ phone }}</span>
    }
    @if (mobilePhone) {
      <span class="phones__row"><span class="phones__label">Mobile</span> {{ mobilePhone }}</span>
    }
  } @else {
    <span>--</span>
  }
</div>
